import React from 'react'

import SectionTitle from '@/components/SectionTitle'
import { mq } from '@/styles/size'

import Product from './Product'
import { PRODUCTS } from './constants'

function OtherProduct(): React.ReactElement {
  return (
    <section
      css={(theme) =>
        mq({
          width: theme.size.width[90],
          maxWidth: theme.size.width[900],
          height: 'auto',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          flexFlow: 'column nowrap',
          margin: 'auto',
          padding: '113px 0 106px 0',
          position: 'relative',
        })
      }
    >
      <SectionTitle>บริการอื่น ๆ ของเรา</SectionTitle>
      <div
        css={mq({
          display: 'grid',
          alignItems: 'center',
          alignContent: 'flex-start',
          justifyContent: 'center',
          gridGap: '24px',
          alignSelf: 'center',
          gridTemplateColumns: [
            'repeat(1, 1fr)',
            'repeat(1, 1fr)',
            'repeat(1, 1fr)',
            'repeat(4, 1fr)',
          ],
          width: '1104px',
          maxWidth: '100%',
          marginTop: '40px',
        })}
      >
        {PRODUCTS.map((product, idx) => {
          const isScrap =
            PRODUCTS.length % 2 !== 0 && PRODUCTS.length === idx + 1

          return <Product {...product} key={product.href} isScrap={isScrap} />
        })}
      </div>
    </section>
  )
}

export default OtherProduct
